import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  FormHelperText,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import ListBook from "./ListBook";
import { CREATE_STUDENT_BOOK } from "../../Schema/StudentBook";
import { GET_CLASS_ITEM_BY_GRADE } from "../../Schema/ClassItem";
import {
  SelectAcademicYear,
  SelectStudent,
  SelectEnrollByStudent,
  SelectWarehouse,
} from "../Include/DynamicSelect";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { GET_STUDENT_PAYMENT_PAGINATOR } from "../../Schema/StudentPayment";

export default function CreateStudentBook({ open, handleClose, setRefetch }) {
  //
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [academicVal, setAcademicVal] = useState({ id: "", title: "" });
  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" });
  const [enrollmentVal, setEnrollmentVal] = useState({
    id: "",
    title: "",
    gradeId: "",
    gradeName: "",
  });
  const [requiredField, setRequiredField] = useState(false);
  const book = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    sellQty: 0,
    key: Date.now() + Math.random(),
  };

  // console.log("studentVal::", academicVal);

  const [bookList, setBookList] = useState([book]);

  const handleAddListBook = () => {
    setBookList([...bookList, book]);
  };

  const handleUpdateListBook = (key, val, fieldName) => {
    const newBook = bookList?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
          d.sellQty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
          d.sellQty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = val;
        }
        if (key === d.key && fieldName === "qty") {
          d.qty = parseFloat(val);
        }
        if (key === d.key && fieldName === "sellQty") {
          d.sellQty = parseFloat(val);
        }
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleDeleteListBook = (key) => {
    const handleDeleteList = bookList?.filter((d) => d.key !== key);
    setBookList([...handleDeleteList]);
  };

  // ========================== get item data ==========================
  const { refetch } = useQuery(GET_CLASS_ITEM_BY_GRADE, {
    variables: {
      gradeId: enrollmentVal?.gradeId ? enrollmentVal?.gradeId : "",
      academicYearId: academicVal?.id ? academicVal?.id : '',
    },
    onCompleted: ({ selectClassItemByGrade }) => {
      console.log("selectClassItemByGrade::", selectClassItemByGrade);
      // console.log("enrollmentVal?.gradeId::", enrollmentVal);
      // 
      if (selectClassItemByGrade?.items?.length > 0 && enrollmentVal?.gradeId) {
        const newListData = selectClassItemByGrade?.items?.map((e) => ({
          key: Date.now() + Math.random(),
          materialId: {
            id: e?.listMaterialUnitId?.materialId?._id,
            // title: "ISBN: " + e?.listMaterialUnitId?.materialId?.isbm + " - " + enrollmentVal?.gradeName,
            // fullName: e?.listMaterialUnitId?.materialId?.materialEnName,
            title: e?.listMaterialUnitId?.materialId?.materialKhName,
            fullName: e?.listMaterialUnitId?.materialId?.materialKhName,
          },
          listMaterialUnitId: {
            id: e?.listMaterialUnitId?._id,
            title: e?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: e?.listMaterialUnitId?.imageSrc,
          },
          qty: e?.qty,
          sellQty: 0,
        }));
        setBookList(newListData);
      } else {
        setBookList([book]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [enrollmentVal?.gradeId]);
  // ========================== end get item data ==========================

  const [createStudentBook] = useMutation(CREATE_STUDENT_BOOK, {
    onCompleted: ({ createStudentBook }) => {
      setLoading(false);
      if (createStudentBook?.status) {
        setAlert(true, "success", createStudentBook?.message);
        handleClose();
        resetForm();
        setRefetch();
        setBookList([book]);
        setStudentVal({ id: "", title: "" });
        setAcademicVal({ id: "", title: "" });
        setWarehouseVal({ id: "", title: "" });
        setEnrollmentVal({ id: "", title: "", gradeId: "", gradeName: "" });
      } else {
        setAlert(true, "error", createStudentBook?.message);
        console.log("error createStudentBook");
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error?.message);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required("require!"),
    studentId: Yup.string().required("require!"),
    enrollmentId: Yup.string().required("require!"),
    warehouseId: Yup.string().required("require!"),
    remark: Yup.string(),
    date: Yup.date(),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      studentId: "",
      enrollmentId: "",
      warehouseId: "",
      remark: "",
      date: new Date(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        bookList?.forEach(function (elem) {
          // console.log("elem", elem);
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty >= 0 &&
            elem?.sellQty >= 0 &&
            elem?.qty + elem?.sellQty > 0
          ) {
            // if (
            //   (elem?.qty === 0 && elem?.sellQty !== 0) ||
            //   (elem?.sellQty === 0 && elem?.qty !== 0)
            // ) {
            console.log("true");
            createStatus = true;
            // } else {
            //   setLoading(false);
            //   setRequiredField(true);
            //   createStatus = false;
            //   throw BreakException;
            // }
          } else {
            console.log("false");
            setLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listProvideBookToSubmit = bookList?.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
            sellQty: parseFloat(d?.sellQty),
          };
        });

        // console.log("listProvideBookToSubmit", listProvideBookToSubmit);
        setLoading(true);
        createStudentBook({
          variables: {
            input: {
              academicYearId: values?.academicYearId,
              studentId: values?.studentId,
              enrollmentId: values?.enrollmentId,
              warehouseId: values?.warehouseId,
              provideBooks: listProvideBookToSubmit,
              remark: values?.remark,
              date: values?.date,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    values,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = formik;

  //==================== When Change Academic ==================
  useEffect(() => {
    if (academicVal?.id) {
      setFieldValue("academicYearId", academicVal?.id);
      window.localStorage.setItem(
        "studentBookAcademicYear",
        JSON.stringify(academicVal)
      );
    } else {
      setFieldValue("academicYearId", "");
    }

    setFieldValue("enrollmentId", "");
    setEnrollmentVal({ id: "", title: "", gradeId: "", gradeName: "", });
  }, [academicVal?.id, open]);

  //=========== Get Academic Year From Localstorage ============
  useEffect(() => {
    let getStudentBookAcademicYear = JSON.parse(
      window.localStorage.getItem("studentBookAcademicYear")
    );
    if (getStudentBookAcademicYear?.id && getStudentBookAcademicYear?.title) {
      setFieldValue("academicYearId", getStudentBookAcademicYear?.id);
      setAcademicVal({
        id: getStudentBookAcademicYear?.id,
        title: getStudentBookAcademicYear?.title,
      });
    }
  }, [open]);

  //================== When Change Student ======================
  useEffect(() => {
    if (studentVal?.id) {
      setFieldValue("studentId", studentVal?.id);
      setBookList([book]);
    } else {
      setFieldValue("studentId", "");
    }

    setFieldValue("enrollmentId", "");
    setEnrollmentVal({ id: "", title: "", gradeId: "", gradeName: "" });
  }, [studentVal?.id, open]);

  //==================== When Change Enrollment ==================
  useEffect(() => {
    if (enrollmentVal?.id) {
      setFieldValue("enrollmentId", enrollmentVal?.id);
    } else {
      setFieldValue("enrollmentId", "");
    }
  }, [enrollmentVal?.id, open]);

  //==================== When Change Warehouse ==================
  useEffect(() => {
    if (warehouseVal?.id) {
      setFieldValue("warehouseId", warehouseVal?.id);
    } else {
      setFieldValue("warehouseId", "");
    }
  }, [warehouseVal?.id, open]);

  //==================== When Change Warehouse ==================
  // useEffect(() => {
  //   if (warehouseVal?.id) {
  //     setFieldValue("warehouseId", warehouseVal?.id);
  //     const newBook = bookList?.map((d) => {
  //       d.listMaterialUnitId = { id: "", title: "" };
  //       d.materialId = "";
  //       return d;
  //     });
  //     setBookList(newBook);
  //   } else {
  //     setWarehouseVal({ id: "", title: "" });
  //     setFieldValue("warehouseId", "");
  //     const newBook = bookList?.map((d) => {
  //       d.listMaterialUnitId = { id: "", title: "" };
  //       d.materialId = "";
  //       return d;
  //     });
  //     setBookList(newBook);
  //   }
  // }, [warehouseVal?.id, dialogTitle]);
  // console.log("vlues", values);

  // 
  const [enrollmentData, setEnrollmentData] = useState(null);
  const { refetch: refetchStudentData, data } = useQuery(GET_STUDENT_PAYMENT_PAGINATOR, {
    variables: {
      page: 1,
      limit: 100,
      pagination: true,
      academicYearId: academicVal?.id ? academicVal?.id : "",
      classId: "",
      schoolId: "",
      studentId: studentVal?.id ? studentVal?.id : "",
      programIds: [],
    },
    onCompleted: ({ getStudentPaymentPagination }) => {
      // console.log("getStudentPaymentPagination:::", getStudentPaymentPagination?.data[0]?.enrollments);      
    },
    onError: (err) => {
      // console.log("Error::", err?.message);
      setEnrollmentData(null)
    },
  });
  useEffect(() => {
    refetchStudentData()
    setEnrollmentData(null)
  }, [academicVal?.id, studentVal?.id])

  useEffect(() => {
    if (data?.getStudentPaymentPagination?.data) {
      let arrayFilter = data?.getStudentPaymentPagination?.data[0]?.enrollments?.filter((e) => e?.enrollment?.classId?.gradeId?.gradeName === enrollmentVal?.gradeName)
      if (arrayFilter?.length > 0) {
        setEnrollmentData(...arrayFilter);
      } else {
        setEnrollmentData(null)
      }
    } else {
      setEnrollmentData(null)
    }
  }, [enrollmentVal?.gradeName])
  console.log("enrollmentData::", enrollmentVal?.gradeName, enrollmentData);


  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតសៀវភៅសិស្ស</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">ឃ្លាំង</Typography>
                <SelectWarehouse
                  selectedVal={warehouseVal}
                  setSelectedVal={setWarehouseVal}
                  defaultValue={true}
                />
                {!!errors.warehouseId && touched.warehouseId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.warehouseId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
                <SelectAcademicYear
                  selectedVal={academicVal}
                  setSelectedVal={setAcademicVal}
                // disabled={!studentVal?.id ? true : false}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">កាលបរិច្ចេទ</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={values?.date}
                    onChange={(newValue) => {
                      setFieldValue("date", newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>


              <Grid item xs={4}>
                <Typography className="field-title">ឈ្មោះសិស្ស</Typography>
                <SelectStudent
                  selectedVal={studentVal}
                  setSelectedVal={setStudentVal}
                />
                {!!errors.studentId && touched.studentId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.studentId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ថ្នាក់</Typography>
                <SelectEnrollByStudent
                  setSelectedVal={setEnrollmentVal}
                  selectedVal={enrollmentVal}
                  academicId={academicVal?.id}
                  studentId={studentVal?.id}
                  disabled={!studentVal?.id ? true : false}
                />
                {!!errors.enrollmentId && touched.enrollmentId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.enrollmentId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">
                  ថ្លៃរដ្ឋបាល
                </Typography>
                {
                  enrollmentData !== null && (
                    <>
                      {enrollmentData?.invoice !== null ? (
                        <Typography sx={{ mt: 1, color: "green" }}>
                          បានបង់
                          {
                            "៖ $ " + enrollmentData?.invoice?.additionalFee?.filter((e) => e?.incomeHead?.incomeType === "AdminFee")[0]?.total || 0
                          }
                        </Typography>
                      ) : (
                        <Typography sx={{ mt: 1, color: "red" }}>
                          មិនបានបង់
                        </Typography>
                      )}
                    </>
                  )
                }
              </Grid>

              <Grid item xs={12}>
                <ListBook
                  handleDeleteList={handleDeleteListBook}
                  handleUpdateList={handleUpdateListBook}
                  handleAddList={handleAddListBook}
                  warehouseId={warehouseVal?.id}
                  requiredField={requiredField}
                  bookList={bookList}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
